import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';

const CLUB_INFO = {
  name: 'WILSON GARDEN CLUB (R)',
  address: 'No. 35/2, 9th Cross, Wilson Garden, Bangalore – 560027',
  phone: '080-2240-0190',
  email: 'wilsongardenclub1951@gmail.com',
  established: 'Est. Since 1951',
  gstin: 'XXXXX',
  pan: 'XXXXX'
};

// Helper function to calculate age from DOB
const calculateAge = (dob) => {
  if (!dob) return null;
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

// Generate Guest Receipt (80mm thermal style)
export const generateGuestReceipt = (guest) => {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: [80, 200]
  });

  let y = 10;
  const centerX = 40;

  // Header
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text(CLUB_INFO.name, centerX, y, { align: 'center' });
  y += 5;

  doc.setFontSize(7);
  doc.setFont('helvetica', 'normal');
  const addressLines = doc.splitTextToSize(CLUB_INFO.address, 70);
  doc.text(addressLines, centerX, y, { align: 'center' });
  y += addressLines.length * 3 + 2;
  doc.text(`Phone: ${CLUB_INFO.phone}`, centerX, y, { align: 'center' });
  y += 4;
  doc.text(`Email: ${CLUB_INFO.email}`, centerX, y, { align: 'center' });
  y += 4;
  doc.text(CLUB_INFO.established, centerX, y, { align: 'center' });
  y += 6;

  // Line
  doc.line(5, y, 75, y);
  y += 6;

  // Title
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text('GUEST ENTRY FORM', centerX, y, { align: 'center' });
  y += 8;

  // Details
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text(`Sl. No.: ${guest.membership_no || ''}`, 5, y);
  y += 5;
  doc.text(`Date: ${guest.date || ''}`, 5, y);
  y += 7;
  doc.text(`Guest Name: ${guest.guest_name || ''}`, 5, y);
  y += 5;
  doc.text(`Member Name: ${guest.member_reference_name || ''}`, 5, y);
  y += 5;
  doc.text(`Remarks: ${guest.remarks || ''}`, 5, y);
  y += 7;

  doc.setFont('helvetica', 'bold');
  doc.text(`Rs.: ${(guest.amount || 0).toLocaleString()}`, 5, y);
  y += 8;

  // Line
  doc.line(5, y, 75, y);
  y += 10;

  // Signature
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.text('_______________________', centerX, y, { align: 'center' });
  y += 5;
  doc.text('Member Signature', centerX, y, { align: 'center' });
  y += 6;
  doc.text('(Valid for this date only)', centerX, y, { align: 'center' });
  y += 6;

  // Line
  doc.line(5, y, 75, y);
  y += 5;
  doc.text('Thank you for visiting', centerX, y, { align: 'center' });

  return doc;
};


// Generate Cash Transaction Receipt
export const generateCashReceipt = (transaction, member) => {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: [80, 220]
  });

  let y = 10;
  const centerX = 40;

  // Header
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text(CLUB_INFO.name, centerX, y, { align: 'center' });
  y += 5;

  doc.setFontSize(7);
  doc.setFont('helvetica', 'normal');
  const addressLines = doc.splitTextToSize(CLUB_INFO.address, 70);
  doc.text(addressLines, centerX, y, { align: 'center' });
  y += addressLines.length * 3 + 2;
  doc.text(`Phone: ${CLUB_INFO.phone}`, centerX, y, { align: 'center' });
  y += 4;
  doc.text(`Email: ${CLUB_INFO.email}`, centerX, y, { align: 'center' });
  y += 6;

  doc.line(5, y, 75, y);
  y += 6;

  // Title
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text('CASH TRANSACTION RECEIPT', centerX, y, { align: 'center' });
  y += 8;

  // Receipt details
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text(`Receipt No: ${transaction.receipt_no || ''}`, 5, y);
  y += 5;
  doc.text(`Date: ${transaction.created_at?.slice(0, 10) || new Date().toISOString().slice(0, 10)}`, 5, y);
  y += 5;
  doc.text(`Time: ${transaction.created_at?.slice(11, 19) || new Date().toISOString().slice(11, 19)}`, 5, y);
  y += 7;

  doc.text(`Member No: ${member?.membership_no || ''}`, 5, y);
  y += 5;
  doc.text(`Member Name: ${member?.applicant_name || ''}`, 5, y);
  y += 7;

  doc.line(5, y, 75, y);
  y += 5;

  doc.text(`Transaction Type: ${transaction.transaction_type || ''}`, 5, y);
  y += 5;
  doc.text(`Payment Mode: ${transaction.payment_mode || ''}`, 5, y);
  y += 5;

  doc.setFont('helvetica', 'bold');
  doc.text(`Amount: ${(transaction.amount || 0).toLocaleString('en-IN')}`, 5, y);
  y += 7;

  doc.line(5, y, 75, y);
  y += 5;

  doc.setFont('helvetica', 'normal');
  const sign = transaction.transaction_type === 'Credit' ? '+' : '-';
  doc.text(`Previous Balance: ${(transaction.previous_balance || 0).toLocaleString('en-IN')}`, 5, y);
  y += 5;
  doc.text(`Transaction: ${sign}${(transaction.amount || 0).toLocaleString('en-IN')}`, 5, y);
  y += 5;

  doc.setFont('helvetica', 'bold');
  doc.text(`New Balance: ${(transaction.new_balance || 0).toLocaleString('en-IN')}`, 5, y);
  y += 7;

  doc.line(5, y, 75, y);
  y += 5;

  if (transaction.note) {
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    const noteLines = doc.splitTextToSize(`Note: ${transaction.note}`, 70);
    doc.text(noteLines, 5, y);
    y += noteLines.length * 4 + 3;
  }

  // Signatures
  y += 5;
  doc.setFontSize(8);
  doc.text('_______________________', centerX, y, { align: 'center' });
  y += 5;
  doc.text('Member Signature', centerX, y, { align: 'center' });
  y += 8;
  doc.text('_______________________', centerX, y, { align: 'center' });
  y += 5;
  doc.text('Cashier Signature', centerX, y, { align: 'center' });
  y += 6;

  doc.line(5, y, 75, y);
  y += 5;
  doc.text('Thank you for your visit', centerX, y, { align: 'center' });

  return doc;
};

// Generate member ledger report
export const generateLedgerReport = (member, ledgerData) => {
  const doc = new jsPDF();
  
  // Header
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text(CLUB_INFO.name, 105, 15, { align: 'center' });
  
  doc.setFontSize(12);
  doc.text('Member Ledger Report', 105, 25, { align: 'center' });
  
  // Member Info
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Member: ${member.applicant_name} (${member.membership_no})`, 14, 40);
  doc.text(`Type: ${member.membership_type}`, 14, 47);
  doc.text(`Mobile: ${member.mobile || 'N/A'}`, 14, 54);
  doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 61);
  
  // Summary boxes
  const summaryY = 70;
  doc.setFillColor(240, 253, 244);
  doc.rect(14, summaryY, 60, 20, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('Total Credit', 16, summaryY + 6);
  doc.setTextColor(34, 197, 94);
  doc.setFontSize(12);
  doc.text(`${(ledgerData.summary.total_credit || 0).toLocaleString('en-IN')}`, 16, summaryY + 14);
  
  doc.setTextColor(0, 0, 0);
  doc.setFillColor(254, 242, 242);
  doc.rect(79, summaryY, 60, 20, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('Total Debit', 81, summaryY + 6);
  doc.setTextColor(239, 68, 68);
  doc.setFontSize(12);
  doc.text(`${(ledgerData.summary.total_debit || 0).toLocaleString('en-IN')}`, 81, summaryY + 14);
  
  doc.setTextColor(0, 0, 0);
  const balanceColor = ledgerData.summary.current_balance >= 0 ? [34, 197, 94] : [239, 68, 68];
  doc.setFillColor(balanceColor[0] > 200 ? 240 : 254, balanceColor[0] > 200 ? 253 : 242, 244);
  doc.rect(144, summaryY, 60, 20, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('Current Balance', 146, summaryY + 6);
  doc.setTextColor(...balanceColor);
  doc.setFontSize(12);
  doc.text(`${(ledgerData.summary.current_balance || 0).toLocaleString('en-IN')}`, 146, summaryY + 14);
  
  doc.setTextColor(0, 0, 0);
  
  // Transactions table
  const tableData = ledgerData.transactions.map((txn, index) => [
    index + 1,
    txn.receipt_no,
    txn.created_at?.slice(0, 10) || '',
    txn.created_at?.slice(11, 16) || '',
    txn.transaction_type,
    `${(txn.amount || 0).toLocaleString('en-IN')}`,
    `${(txn.new_balance || 0).toLocaleString('en-IN')}`,
    txn.payment_mode,
    txn.note || ''
  ]);
  
  autoTable(doc, {
    startY: summaryY + 28,
    head: [['#', 'Receipt', 'Date', 'Time', 'Type', 'Amount', 'Balance', 'Mode', 'Note']],
    body: tableData,
    theme: 'striped',
    headStyles: {
      fillColor: [59, 130, 246],
      fontSize: 9,
      fontStyle: 'bold'
    },
    bodyStyles: {
      fontSize: 8
    },
    columnStyles: {
      0: { cellWidth: 10 },
      1: { cellWidth: 20 },
      2: { cellWidth: 22 },
      3: { cellWidth: 15 },
      4: { cellWidth: 18 },
      5: { cellWidth: 25 },
      6: { cellWidth: 25 },
      7: { cellWidth: 20 },
      8: { cellWidth: 'auto' }
    },
    didParseCell: function(data) {
      if (data.section === 'body' && data.column.index === 4) {
        if (data.cell.text[0] === 'Credit') {
          data.cell.styles.textColor = [34, 197, 94];
        } else if (data.cell.text[0] === 'Debit') {
          data.cell.styles.textColor = [239, 68, 68];
        }
      }
    }
  });
  
  // Footer
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.text(
      `Page ${i} of ${pageCount}`,
      doc.internal.pageSize.getWidth() / 2,
      doc.internal.pageSize.getHeight() - 10,
      { align: 'center' }
    );
  }
  
  return doc;
};


export const generateSubscriptionReceipt = (payment, member) => {
  try {
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [80, 200]
    });

    let y = 10;
    const centerX = 40;
    const margin = 5;
    const pageWidth = 80;

    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text(CLUB_INFO.name, centerX, y, { align: 'center' });
    y += 5;

    doc.setFontSize(7);
    doc.setFont('helvetica', 'normal');
    doc.text(CLUB_INFO.address, centerX, y, { align: 'center' });
    y += 3.5;

    if (CLUB_INFO.city) {
      doc.text(CLUB_INFO.city, centerX, y, { align: 'center' });
      y += 3.5;
    }

    doc.text(`Phone: ${CLUB_INFO.phone}`, centerX, y, { align: 'center' });
    y += 3.5;
    doc.text(`Email: ${CLUB_INFO.email}`, centerX, y, { align: 'center' });
    y += 5;

    doc.setLineWidth(0.3);
    doc.line(margin, y, pageWidth - margin, y);
    y += 5;

    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('SUBSCRIPTION RECEIPT', centerX, y, { align: 'center' });
    y += 7;

    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text(`Receipt No : ${payment.receipt_no || ''}`, margin, y);
    y += 4;
    doc.text(
      `Date       : ${payment.payment_date || new Date().toISOString().split('T')[0]}`,
      margin,
      y
    );
    y += 6;

    doc.line(margin, y, pageWidth - margin, y);
    y += 5;

    doc.setFont('helvetica', 'bold');
    doc.text('Received from:', margin, y);
    y += 5;

    doc.setFont('helvetica', 'normal');
    doc.text(`Name  : ${member.applicant_name || ''}`, margin, y);
    y += 4;
    doc.text(`Member: ${member.membership_no || ''}`, margin, y);
    y += 4;
    doc.text(`Mobile: ${member.mobile || ''}`, margin, y);
    y += 6;

    doc.line(margin, y, pageWidth - margin, y);
    y += 5;

    doc.setFont('helvetica', 'bold');
    doc.text('Description', margin, y);
    doc.text('M', 44, y);
    doc.text('Amount', 56, y);
    y += 4;

    doc.line(margin, y, pageWidth - margin, y);
    y += 4;

    doc.setFont('helvetica', 'normal');
    doc.text('Club Subscription', margin, y);
    doc.text(String(payment.months_covered || 0), 44, y);
    doc.text(
      `${(payment.payment_amount || 0).toLocaleString('en-IN')}`,
      56,
      y
    );
    y += 5;

    doc.line(margin, y, pageWidth - margin, y);
    y += 4;

    doc.setFont('helvetica', 'bold');
    doc.text('TOTAL PAID', margin, y);
    doc.text(
      `${(payment.payment_amount || 0).toLocaleString('en-IN')}`,
      56,
      y
    );
    y += 5;

    doc.line(margin, y, pageWidth - margin, y);
    y += 5;

    doc.setFont('helvetica', 'normal');
    doc.text(`Payment Mode : ${payment.payment_mode || 'CASH'}`, margin, y);
    y += 7;

    const amountInWords = numberToWords(payment.payment_amount || 0);
    doc.text('Amount in Words:', margin, y);
    y += 4;

    const wordLines = doc.splitTextToSize(
      `${amountInWords} Rupees Only`,
      pageWidth - margin * 2
    );
    doc.text(wordLines, margin, y);
    y += wordLines.length * 4 + 4;

    doc.line(margin, y, pageWidth - margin, y);
    y += 7;

    doc.text('__________________________', centerX, y, { align: 'center' });
    y += 4;
    doc.text('Member Signature', centerX, y, { align: 'center' });
    y += 8;

    doc.text('__________________________', centerX, y, { align: 'center' });
    y += 4;
    doc.text('Cashier Signature', centerX, y, { align: 'center' });
    y += 6;

    doc.line(margin, y, pageWidth - margin, y);
    y += 4;

    doc.setFontSize(7);
    doc.text('NOTE:', margin, y);
    y += 3;
    doc.text('• Applicable only for Permanent Members', margin, y);
    y += 3;
    doc.text('• Monthly Subscription Fee: 200', margin, y);
    y += 3;
    doc.text('• Members aged 65 years & above are FREE', margin, y);

    return doc;
  } catch (error) {
    console.error('Error generating subscription receipt:', error);
    throw new Error('Failed to generate receipt. Please try again.');
  }
};

const numberToWords = (num) => {
  if (!num || isNaN(num)) return 'Zero';

  const a = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
    'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
    'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
    'Seventeen', 'Eighteen', 'Nineteen'
  ];

  const b = [
    '', '', 'Twenty', 'Thirty', 'Forty',
    'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
  ];

  const inWords = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
    if (n < 1000)
      return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + inWords(n % 100) : '');
    if (n < 100000)
      return inWords(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + inWords(n % 1000) : '');
    if (n < 10000000)
      return inWords(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + inWords(n % 100000) : '');
    return inWords(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 ? ' ' + inWords(n % 10000000) : '');
  };

  return inWords(Math.floor(num));
};


// Generate Membership Application Form (A4 Format)
export const generateMembershipForm = (memberData) => {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 15;
  let yPos = 15;

// ================= HEADER =================
const headerTop = 10;
const headerHeight = 25;

doc.setLineWidth(0.5);
doc.rect(margin, headerTop, pageWidth - 2 * margin, headerHeight);

let headerY = headerTop + 7;

doc.setFontSize(14);
doc.setFont('helvetica', 'bold');
doc.text(CLUB_INFO.name, pageWidth / 2, headerY, { align: 'center' });

headerY += 5;
doc.setFontSize(9);
doc.setFont('helvetica', 'normal');
doc.text(
  'NO. 35/2, 9TH CROSS, WILSON GARDEN, BANGALORE – 560027',
  pageWidth / 2,
  headerY,
  { align: 'center' }
);

headerY += 4;
doc.text(
  'PHONE: 080-4130-0190 | EMAIL: WILSONGARDENCLUB1951@GMAIL.COM',
  pageWidth / 2,
  headerY,
  { align: 'center' }
);

headerY += 4;
doc.text(
  'ESTD: 1951 | GST: XXXXX | PAN: XXXXX',
  pageWidth / 2,
  headerY,
  { align: 'center' }
);

// ================= TITLE =================
yPos = headerTop + headerHeight + 10;

doc.setFontSize(12);
doc.setFont('helvetica', 'bold');
doc.text('CLUB MEMBERSHIP APPLICATION FORM', pageWidth / 2, yPos, {
  align: 'center'
});

yPos += 5;
doc.setFontSize(10);
doc.text(
  `(${memberData.membership_type?.toUpperCase() || 'PERMANENT'} MEMBERSHIP)`,
  pageWidth / 2,
  yPos,
  { align: 'center' }
);

yPos += 10;

// ================= BASIC INFO + PHOTO =================
const baseY = yPos;
const infoHeight = 30;          // unified height
const photoWidth = 40;

// Left info box
doc.setLineWidth(0.3);
doc.rect(
  margin,
  baseY,
  pageWidth - 2 * margin - photoWidth,
  infoHeight
);

// Right photo box
const photoX = pageWidth - margin - photoWidth;
doc.rect(photoX, baseY, photoWidth, infoHeight);

// ---- Left text (anchored, no drifting) ----
let textY = baseY + 7;
doc.setFontSize(9);
doc.setFont('helvetica', 'normal');

doc.text(`Membership No : ${memberData.membership_no || '_______________'}`, margin + 3, textY);
textY += 5;

doc.text(`Date          : ${memberData.date || '_______________'}`, margin + 3, textY);
textY += 5;
doc.text(`Type          : ${memberData.membership_type?.toUpperCase() || 'PERMANENT'}`, margin + 3, textY);
textY += 5;
doc.text(`Status        : ${memberData.status?.toUpperCase() || 'ACTIVE'}`, margin + 3, textY);

// ---- Photo placeholder (true vertical centering) ----
const photoCenterX = photoX + photoWidth / 2;
let photoTextY = baseY + infoHeight / 2 - 6;

doc.setFontSize(7);
doc.text('PASSPORT SIZE', photoCenterX, photoTextY, { align: 'center' });
photoTextY += 4;
doc.text('PHOTO', photoCenterX, photoTextY, { align: 'center' });
photoTextY += 4;
doc.text('3.5cm x 4.5cm', photoCenterX, photoTextY, { align: 'center' });

// Move cursor cleanly below section
yPos = baseY + infoHeight + 12;

  // Personal Information
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('PERSONAL INFORMATION', margin, yPos);

  yPos += 2;
  doc.setLineWidth(0.5);
  doc.line(margin, yPos, pageWidth - margin, yPos);

  yPos += 5;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text(`Name of Applicant     : ${memberData.applicant_name || '___________________________________________'}`, margin, yPos);

  yPos += 6;
  doc.text(`Father's Name         : ${memberData.father_name || '___________________________________________'}`, margin, yPos);

  yPos += 6;
  const age = calculateAge(memberData.dob);
  const ageText = age ? ` (${age} years)` : '';
  doc.text(`Date of Birth         : ${memberData.dob || '____ / ____ / ______'}${ageText}    Sex : ${memberData.sex || '☐ Male ☐ Female'}`, margin, yPos);

  yPos += 6;
  doc.text(`Marital Status        : ${memberData.marital_status || '☐ Married ☐ Unmarried'}`, margin, yPos);

  yPos += 6;
  doc.text(`Nationality           : ${memberData.nationality || '☐ Indian ☐ Other'}`, margin, yPos);

  yPos += 6;
  doc.text(`Aadhaar Number        : ${memberData.aadhaar || '___________________________________________'}`, margin, yPos);

  yPos += 6;
  doc.text(`PAN Number            : ${memberData.pan || '___________________________________________'}`, margin, yPos);

  yPos += 6;
  doc.text(`Mobile No             : ${memberData.mobile || '___________________________________________'}`, margin, yPos);

  yPos += 6;
  doc.text(`Email                 : ${memberData.email || '___________________________________________'}`, margin, yPos);

  yPos += 8;

  // Professional Details
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('PROFESSIONAL DETAILS', margin, yPos);

  yPos += 2;
  doc.line(margin, yPos, pageWidth - margin, yPos);

  yPos += 5;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text(`Qualification         : ${memberData.qualification || '___________________________________________'}`, margin, yPos);

  yPos += 6;
  doc.text(`Organisation          : ${memberData.organization || '___________________________________________'}`, margin, yPos);

  yPos += 6;
  doc.text(`Designation           : ${memberData.designation || '___________________________________________'}`, margin, yPos);

  yPos += 8;

  // Address
  doc.text(`Residential Address:`, margin, yPos);
  yPos += 5;
  const addressLines = doc.splitTextToSize(memberData.address || '_______________________________________________________________', pageWidth - 2 * margin);
  doc.text(addressLines, margin, yPos);
  yPos += addressLines.length * 5;

  yPos += 6;

  // Spouse Details (if married)
  if (memberData.marital_status === 'Married') {
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('SPOUSE DETAILS (ONLY IF MARRIED)', margin, yPos);

    yPos += 2;
    doc.line(margin, yPos, pageWidth - margin, yPos);

    yPos += 5;
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text(`Spouse Name           : ${memberData.spouse_name || '___________________________________________'}`, margin, yPos);

    yPos += 6;
    const spouseAge = calculateAge(memberData.spouse_dob);
    const spouseAgeText = spouseAge ? ` (${spouseAge} years)` : '';
    doc.text(`Spouse DOB            : ${memberData.spouse_dob || '____ / ____ / ______'}${spouseAgeText}`, margin, yPos);

    yPos += 6;
    doc.text(`Spouse Qualification  : ${memberData.spouse_qualification || '___________________________________________'}`, margin, yPos);

    yPos += 6;
    doc.text(`Spouse Occupation     : ${memberData.spouse_occupation || '___________________________________________'}`, margin, yPos);

    yPos += 8;
  }

  // Check if we need a new page
  if (yPos > 240) {
    doc.addPage();
    yPos = 15;
  }

  // Temporary Membership Period
  if (memberData.membership_type === 'Temporary') {
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('TEMPORARY MEMBERSHIP PERIOD', margin, yPos);

    yPos += 2;
    doc.line(margin, yPos, pageWidth - margin, yPos);

    yPos += 5;
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text(`Subscription From     : ${memberData.subscription_from || '____ / ____ / ______'}`, margin, yPos);

    yPos += 6;
    doc.text(`Subscription To       : ${memberData.subscription_to || '____ / ____ / ______'}`, margin, yPos);

    yPos += 8;
  }

  // Financial Details
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('FINANCIAL DETAILS', margin, yPos);

  yPos += 2;
  doc.line(margin, yPos, pageWidth - margin, yPos);

  yPos += 5;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text(`Membership Fee Paid   :  ${memberData.membership_fee || '______________________'}`, margin, yPos);

  yPos += 6;
  doc.text(`Opening Balance       :  ${memberData.opening_balance || '______________________'}`, margin, yPos);

  yPos += 6;
  doc.text('Amount in Words: _______________________________________________________________', margin, yPos);

  yPos += 8;

  // Dependants Table
  if (memberData.dependants && memberData.dependants.length > 0) {
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('DEPENDANTS DETAILS', margin, yPos);

    yPos += 5;

    const dependantsData = memberData.dependants.map(dep => {
      const depAge = calculateAge(dep.dob);
      return [
        dep.name || '',
        dep.sex || '',
        dep.relation || '',
        dep.dob || '',
        depAge ? depAge.toString() : '',
        dep.occupation || ''
      ];
    });

    autoTable(doc, {
  startY: yPos,
  head: [['Name', 'Sex', 'Relation', 'Date of Birth', 'Age', 'Occupation']],
  body: dependantsData,
  theme: 'grid',
  styles: { fontSize: 8 },
  margin: { left: margin, right: margin }
});

yPos = doc.lastAutoTable?.finalY
  ? doc.lastAutoTable.finalY + 8
  : yPos + 10;
}

  // Games of Interest
  if (Array.isArray(memberData.games_of_interest) && memberData.games_of_interest.length > 0) {
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('GAMES OF INTEREST', margin, yPos);

    yPos += 2;
    doc.line(margin, yPos, pageWidth - margin, yPos);

    yPos += 5;
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    const gamesText = doc.splitTextToSize(memberData.games_of_interest.join(', '), pageWidth - 2 * margin);
    doc.text(gamesText, margin, yPos);
    yPos += gamesText.length * 5;

    yPos += 8;
  }

  // Check if we need a new page for declaration
  if (yPos > 230) {
    doc.addPage();
    yPos = 15;
  }

  // Declaration
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('DECLARATION', margin, yPos);

  yPos += 2;
  doc.line(margin, yPos, pageWidth - margin, yPos);

  yPos += 5;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text('I hereby declare that the information furnished above is true and', margin, yPos);
  yPos += 5;
  doc.text('correct to the best of my knowledge and belief.', margin, yPos);

  yPos += 10;

  // Signature Section
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('SIGNATURE', margin, yPos);

  yPos += 2;
  doc.line(margin, yPos, pageWidth - margin, yPos);

  yPos += 8;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text('Place : ______________________', margin, yPos);

  yPos += 8;
  doc.text('Date  : ____ / ____ / ______', margin, yPos);

  yPos += 15;
  doc.line(margin, yPos, 70, yPos);
  yPos += 4;
  doc.text('Signature of Applicant', margin, yPos);

  doc.line(pageWidth - margin - 55, yPos - 4, pageWidth - margin, yPos - 4);
  yPos += 4;
  doc.text('Authorised Signatory', pageWidth - margin - 50, yPos);

  yPos += 10;

  // Validity Note
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('VALIDITY NOTE', margin, yPos);

  yPos += 2;
  doc.line(margin, yPos, pageWidth - margin, yPos);

  yPos += 5;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  if (memberData.membership_type === 'Permanent') {
    doc.text('Permanent Membership : Valid until cancelled', margin, yPos);
  } else {
    doc.text(`Temporary Membership : Valid until ${memberData.subscription_to || 'Subscription To date'}`, margin, yPos);
  }

  return doc;
};

// Generate A4 Members Report
export const generateMembersReport = (members, title = 'Members Report') => {
  const doc = new jsPDF();

  // Header
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text(CLUB_INFO.name, 105, 15, { align: 'center' });

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(CLUB_INFO.address, 105, 22, { align: 'center' });

  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text(title, 105, 35, { align: 'center' });

  // Table
  const tableData = members.map((m, i) => {
    const age = calculateAge(m.dob);
    const ageDisplay = age ? `${age} years` : '-';

    return [
      i + 1,
      m.membership_no || '',
      m.applicant_name || m.guest_name || '',
      m.membership_type || '',
      m.mobile || '',
      ageDisplay,
      m.status || ''
    ];
  });

  autoTable(doc, {
  startY: 45,
  head: [['#', 'Member No', 'Name', 'Type', 'Mobile', 'Age', 'Status']],
  body: tableData,
  styles: { fontSize: 8 },
  headStyles: { fillColor: [59, 130, 246] }
});


  // Footer
  const finalY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(8);
  doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, finalY);
  doc.text(`Total Members: ${members.length}`, 14, finalY + 5);

  return doc;
};


// Club branding colors
const COLORS = {
  primary: '#10b981',    // Green
  secondary: '#059669',  // Darker green
  accent: '#fbbf24',     // Yellow
  text: '#1f2937',       // Dark gray
  lightBg: '#f3f4f6',    // Light gray
  border: '#d1d5db',     // Gray border
};

/**
 * Generate Game Report PDF
 */
export const generateGameReportPDF = async (games, filters = {}) => {
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  let yPos = 20;

  // Header
  pdf.setFillColor(16, 185, 129); // Green
  pdf.rect(0, 0, pageWidth, 40, 'F');
  
  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(24);
  pdf.setFont('helvetica', 'bold');
  pdf.text('KITTY RUMMY - GAME REPORT', pageWidth / 2, 20, { align: 'center' });
  
  pdf.setFontSize(12);
  pdf.setFont('helvetica', 'normal');
  pdf.text(`Generated: ${new Date().toLocaleDateString('en-GB')} ${new Date().toLocaleTimeString('en-GB')}`, pageWidth / 2, 30, { align: 'center' });

  yPos = 50;

  // Summary Section
  pdf.setFillColor(249, 250, 251);
  pdf.rect(15, yPos, pageWidth - 30, 30, 'F');
  
  pdf.setTextColor(31, 41, 55);
  pdf.setFontSize(14);
  pdf.setFont('helvetica', 'bold');
  pdf.text('SUMMARY', 20, yPos + 10);
  
  pdf.setFontSize(10);
  pdf.setFont('helvetica', 'normal');
  
  const totalGames = games.length;
  const totalKP = games.reduce((sum, g) => sum + (g.total_kitty || 0), 0);
  const stakeGames = games.filter(g => g.table_type === 'STAKE').length;
  const syndicateGames = games.filter(g => g.table_type === 'SYNDICATE').length;

  pdf.text(`Total Games: ${totalGames}`, 20, yPos + 20);
  pdf.text(`Total KP: ${totalKP}`, 75, yPos + 20);
  pdf.text(`STAKE: ${stakeGames}`, 130, yPos + 20);
  pdf.text(`SYNDICATE: ${syndicateGames}`, 165, yPos + 20);

  yPos += 40;

  // Games Table
  pdf.setFontSize(12);
  pdf.setFont('helvetica', 'bold');
  pdf.text('GAMES DETAILS', 20, yPos);
  yPos += 8;

  // Table headers
  pdf.setFillColor(16, 185, 129);
  pdf.rect(15, yPos, pageWidth - 30, 8, 'F');
  
  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(9);
  pdf.text('Game No', 20, yPos + 5);
  pdf.text('Type', 55, yPos + 5);
  pdf.text('Table', 80, yPos + 5);
  pdf.text('Group', 100, yPos + 5);
  pdf.text('Players', 120, yPos + 5);
  pdf.text('Rounds', 145, yPos + 5);
  pdf.text('KP', 165, yPos + 5);
  pdf.text('Duration', 180, yPos + 5);

  yPos += 10;

  // Table rows
  pdf.setTextColor(31, 41, 55);
  pdf.setFont('helvetica', 'normal');

  games.forEach((game, index) => {
    if (yPos > pageHeight - 30) {
      pdf.addPage();
      yPos = 20;
    }

    // Alternating row colors
    if (index % 2 === 0) {
      pdf.setFillColor(249, 250, 251);
      pdf.rect(15, yPos - 5, pageWidth - 30, 8, 'F');
    }

    pdf.text(game.game_no, 20, yPos);
    pdf.text(game.table_type, 55, yPos);
    pdf.text(String(game.table_no), 80, yPos);
    pdf.text(game.group_name, 100, yPos);
    pdf.text(String(game.players?.length || 0), 120, yPos);
    pdf.text(String(game.rounds_count || 0), 145, yPos);
    pdf.text(String(game.total_kitty || 0), 165, yPos);
    pdf.text(game.duration || '-', 180, yPos);

    yPos += 8;
  });

  // Footer
  const totalPages = pdf.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    pdf.setFontSize(8);
    pdf.setTextColor(107, 114, 128);
    pdf.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
    pdf.text('© Kitty Rummy Management System', pageWidth / 2, pageHeight - 5, { align: 'center' });
  }

  return pdf;
};

/**
 * Generate Round-wise Report PDF
 */
export const generateRoundReportPDF = async (games) => {
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  let yPos = 20;

  // Header
  pdf.setFillColor(139, 92, 246); // Purple
  pdf.rect(0, 0, pageWidth, 40, 'F');
  
  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(24);
  pdf.setFont('helvetica', 'bold');
  pdf.text('KITTY RUMMY - ROUND REPORT', pageWidth / 2, 20, { align: 'center' });
  
  pdf.setFontSize(12);
  pdf.setFont('helvetica', 'normal');
  pdf.text(`Generated: ${new Date().toLocaleDateString('en-GB')} ${new Date().toLocaleTimeString('en-GB')}`, pageWidth / 2, 30, { align: 'center' });

  yPos = 50;

  games.forEach((game, gameIndex) => {
    if (yPos > pageHeight - 40) {
      pdf.addPage();
      yPos = 20;
    }

    // Game header
    pdf.setFillColor(243, 244, 246);
    pdf.rect(15, yPos, pageWidth - 30, 15, 'F');
    
    pdf.setFontSize(12);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(31, 41, 55);
    pdf.text(`GAME: ${game.game_no} | Table ${game.table_no} | ${game.table_type}`, 20, yPos + 7);
    pdf.setFontSize(9);
    pdf.text(`Group: ${game.group_name} | Players: ${game.players?.length || 0}`, 20, yPos + 12);

    yPos += 20;

    // Rounds
    if (game.rounds && game.rounds.length > 0) {
      game.rounds.forEach((round, roundIndex) => {
        if (yPos > pageHeight - 50) {
          pdf.addPage();
          yPos = 20;
        }

        pdf.setFontSize(10);
        pdf.setFont('helvetica', 'bold');
        pdf.text(`Round ${round.round_number}`, 20, yPos);
        pdf.setFont('helvetica', 'normal');
        pdf.text(`KP: ${round.kitty_points}`, 50, yPos);

        yPos += 7;

        // Round scores table
        pdf.setFillColor(16, 185, 129);
        pdf.rect(20, yPos, pageWidth - 40, 6, 'F');
        
        pdf.setTextColor(255, 255, 255);
        pdf.setFontSize(8);
        pdf.text('Player', 25, yPos + 4);
        pdf.text('Points', 100, yPos + 4);
        pdf.text('Action', 130, yPos + 4);
        pdf.text('Status', 160, yPos + 4);

        yPos += 8;

        pdf.setTextColor(31, 41, 55);
        round.scores.forEach((score, scoreIndex) => {
          if (yPos > pageHeight - 30) {
            pdf.addPage();
            yPos = 20;
          }

          if (scoreIndex % 2 === 0) {
            pdf.setFillColor(249, 250, 251);
            pdf.rect(20, yPos - 4, pageWidth - 40, 6, 'F');
          }

          pdf.text(score.player_name, 25, yPos);
          pdf.text(String(score.points), 100, yPos);
          pdf.text(score.action, 130, yPos);
          
          if (score.is_winner) {
            pdf.setTextColor(16, 185, 129);
            pdf.setFont('helvetica', 'bold');
            pdf.text('WINNER', 160, yPos);
            pdf.setFont('helvetica', 'normal');
            pdf.setTextColor(31, 41, 55);
          } else {
            pdf.text('-', 160, yPos);
          }

          yPos += 6;
        });

        yPos += 5;
      });
    } else {
      pdf.setFontSize(9);
      pdf.setTextColor(107, 114, 128);
      pdf.text('No rounds played', 20, yPos);
      yPos += 10;
    }

    yPos += 10;
  });

  // Footer
  const totalPages = pdf.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    pdf.setFontSize(8);
    pdf.setTextColor(107, 114, 128);
    pdf.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
    pdf.text('© Kitty Rummy Management System', pageWidth / 2, pageHeight - 5, { align: 'center' });
  }

  return pdf;
};

/**
 * Generate Player History PDF
 */
export const generatePlayerHistoryPDF = async (playerData) => {
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  let yPos = 20;

  // Header
  pdf.setFillColor(59, 130, 246); // Blue
  pdf.rect(0, 0, pageWidth, 45, 'F');
  
  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(22);
  pdf.setFont('helvetica', 'bold');
  pdf.text('PLAYER HISTORY REPORT', pageWidth / 2, 18, { align: 'center' });
  
  pdf.setFontSize(16);
  pdf.text(playerData.player_name, pageWidth / 2, 28, { align: 'center' });
  
  pdf.setFontSize(10);
  pdf.setFont('helvetica', 'normal');
  if (playerData.member_no) {
    pdf.text(`Member No: ${playerData.member_no}`, pageWidth / 2, 35, { align: 'center' });
  }
  pdf.text(`Generated: ${new Date().toLocaleDateString('en-GB')}`, pageWidth / 2, 40, { align: 'center' });

  yPos = 55;

  // Statistics Section
  pdf.setFillColor(239, 246, 255);
  pdf.rect(15, yPos, pageWidth - 30, 25, 'F');
  
  pdf.setTextColor(31, 41, 55);
  pdf.setFontSize(12);
  pdf.setFont('helvetica', 'bold');
  pdf.text('STATISTICS', 20, yPos + 8);
  
  pdf.setFontSize(10);
  pdf.setFont('helvetica', 'normal');
  pdf.text(`Games Played: ${playerData.games_played}`, 20, yPos + 16);
  
  const netWinLoss = playerData.net_winloss || 0;
  const isPositive = netWinLoss >= 0;
  pdf.setTextColor(isPositive ? 16 : 220, isPositive ? 185 : 38, isPositive ? 129 : 38);
  pdf.setFont('helvetica', 'bold');
  pdf.text(`Net Win/Loss: ${isPositive ? '+' : ''}${netWinLoss}`, 90, yPos + 16);
  
  pdf.setTextColor(31, 41, 55);
  pdf.setFont('helvetica', 'normal');

  yPos += 35;

  // Games History
  pdf.setFontSize(12);
  pdf.setFont('helvetica', 'bold');
  pdf.text('GAME HISTORY', 20, yPos);
  yPos += 8;

  if (playerData.games && playerData.games.length > 0) {
    playerData.games.forEach((game, index) => {
      if (yPos > pageHeight - 60) {
        pdf.addPage();
        yPos = 20;
      }

      // Game card
      pdf.setFillColor(249, 250, 251);
      pdf.rect(15, yPos, pageWidth - 30, 45, 'F');
      pdf.setDrawColor(209, 213, 219);
      pdf.rect(15, yPos, pageWidth - 30, 45, 'S');

      pdf.setFontSize(11);
      pdf.setFont('helvetica', 'bold');
      pdf.text(`${game.game_no}`, 20, yPos + 7);
      
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`Table: ${game.table_no} | Type: ${game.table_type} | Group: ${game.group_name}`, 20, yPos + 13);
      
      const startDate = new Date(game.started_at);
      pdf.text(`Date: ${startDate.toLocaleDateString('en-GB')} ${startDate.toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit'})}`, 20, yPos + 19);
      pdf.text(`Duration: ${game.duration || '-'}`, 20, yPos + 25);
      pdf.text(`Rounds Played: ${game.rounds_count || 0}`, 20, yPos + 31);

      // Find player's score in this game
      let playerTotalPoints = 0;
      let gamesWon = 0;
      
      if (game.rounds) {
        game.rounds.forEach(round => {
          const playerScore = round.scores.find(s => s.player_name === playerData.player_name);
          if (playerScore) {
            playerTotalPoints += playerScore.points;
            if (playerScore.is_winner) gamesWon++;
          }
        });
      }

      pdf.setFont('helvetica', 'bold');
      const scoreColor = playerTotalPoints >= 0 ? [16, 185, 129] : [220, 38, 38];
      pdf.setTextColor(...scoreColor);
      pdf.text(`Score: ${playerTotalPoints >= 0 ? '+' : ''}${playerTotalPoints}`, 20, yPos + 37);
      
      pdf.setTextColor(31, 41, 55);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`Wins: ${gamesWon}`, 80, yPos + 37);

      yPos += 50;
    });
  } else {
    pdf.setFontSize(10);
    pdf.setTextColor(107, 114, 128);
    pdf.text('No game history found', 20, yPos);
    yPos += 15;
  }

  // Footer
  const totalPages = pdf.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    pdf.setFontSize(8);
    pdf.setTextColor(107, 114, 128);
    pdf.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
    pdf.text('© Kitty Rummy Management System', pageWidth / 2, pageHeight - 5, { align: 'center' });
  }

  return pdf;
};

/**
 * Download PDF
 */
export const downloadPDF = (pdf, filename) => {
  pdf.save(filename);
};

/**
 * Print PDF
 */
export const printPDF = (pdf) => {
  const blob = pdf.output('blob');
  const url = URL.createObjectURL(blob);
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = url;
  document.body.appendChild(iframe);
  iframe.onload = () => {
    iframe.contentWindow.print();
  };
};

export default {
  generateGameReportPDF,
  generateRoundReportPDF,
  generatePlayerHistoryPDF,
  downloadPDF,
  printPDF,
  generateGuestReceipt,
  generateCashReceipt,
  generateSubscriptionReceipt,
  generateMembershipForm,
  generateMembersReport
};
